import { Drawer, IconButton, Box, Typography, useTheme, Collapse, SwipeableDrawer, Tooltip } from '@mui/material'
import { ALIVE_SUPPORT_URL, ERPFacultyDashboardPageURL } from '../../../../shared/utils/constants.jsx'
import { useLayoutContext } from '../../../../shared/contexts/layout.context'
import aliveLogo from '../../../../shared/assets/alivelogo.png'
import { Icons } from '../../../../shared/utils/icons.jsx'
import React, { useState } from 'react'

import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useUserStore } from '../../../store/user.store'
import CustomSwitch from '../../../../shared/components/common/CustomSwitch'

const closedSidebarWidth = 60

const getCodingLabsLink = () => {
    const prod = true
    const baseUrl = prod ? `https://codelabs.alive.university` : `http://localhost:5173`

    if ( sessionStorage.getItem( "impersonation_id_token" ) )
        return `${baseUrl}/sso?token=${sessionStorage.getItem( "impersonation_id_token" )}`
    return `${baseUrl}/sso?token=${localStorage.getItem( 'id_token' )}`
}

export const EcosystemPortalCard = ( { isSideDrawerCollapsed } ) => {
    const theme = useTheme()
    const isDark = theme.palette.mode === 'dark'

    return (
        <Link
            to="/auditor/dashboard"
            target="_placements"
            className="default-link"
            style={{ textDecoration: 'none', display: 'block', width: '100%', position: "sticky", bottom: 0, marginTop: "20px" }}
        >
            <Box
                sx={{
                    mb: 1,
                    position: 'sticky',
                    bottom: 0,
                    overflow: 'hidden',
                    borderRadius: 2.5,
                    p: isSideDrawerCollapsed ? 0 : 1,
                    cursor: 'pointer',
                    width: '100%',

                    background: isDark
                        ? `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[900]} 100%)`
                        : `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.secondary.light} 100%)`,

                    color: theme.palette.text.primary,
                    border: '1px solid transparent',
                    borderColor: isDark
                        ? 'rgba(255, 255, 255, 0.12)'
                        : 'rgba(0, 0, 0, 0.08)',

                    boxShadow: isDark
                        ? '0 4px 20px rgba(0, 0, 0, 0.4)'
                        : '0 4px 20px rgba(0, 0, 0, 0.05)',

                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

                    '&:hover': {
                        transform: 'translateY(-2px)',
                        borderColor: theme.palette.secondary.main,
                        boxShadow: isDark
                            ? `0 8px 25px ${theme.palette.secondary.main}33`
                            : `0 8px 25px ${theme.palette.secondary.main}20`,
                        '& .arrow-icon': {
                            transform: 'translate(3px, -3px)',
                            color: theme.palette.secondary.main,
                            bgcolor: isDark ? 'rgba(255, 255, 255, 0.1)' : theme.palette.action.hover,
                        },
                        '& .bg-glow': {
                            opacity: isDark ? 0.25 : 0.4,
                            transform: 'scale(1.2)',
                        },
                    },
                }}
            >
                {/* Background Glow */}
                <Box
                    className="bg-glow"
                    sx={{
                        position: 'absolute',
                        top: -20,
                        right: -20,
                        width: 100,
                        height: 100,
                        borderRadius: '50%',
                        background: theme.palette.secondary.main,
                        opacity: isDark ? 0.12 : 0.15,
                        filter: 'blur(25px)',
                        transition: 'all 0.5s ease',
                        pointerEvents: 'none',
                    }}
                />

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                    <Box sx={{ width: isSideDrawerCollapsed ? "100%" : "auto", display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        {/* Icon Container */}
                        <Tooltip arrow placement="right" title={isSideDrawerCollapsed ? "Switch to Placement Training" : ""}>
                            <Box
                                sx={{
                                    width: isSideDrawerCollapsed ? "100%" : "auto",
                                    p: 1.2,
                                    borderRadius: 2,
                                    bgcolor: isDark
                                        ? 'rgba(255, 255, 255, 0.06)'
                                        : 'rgba(0, 0, 0, 0.04)',
                                    color: theme.palette.secondary.main,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {Icons.default.Building1}
                            </Box>
                        </Tooltip>

                        {!isSideDrawerCollapsed && <Box>
                            <Typography
                                noWrap
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 600,
                                    lineHeight: 1.2,
                                    color: theme.palette.text.primary
                                }}
                            >
                                Placement Training
                            </Typography>
                        </Box>}
                    </Box>

                    {/* Action Icon */}
                    {!isSideDrawerCollapsed && <Box
                        className="arrow-icon"
                        sx={{
                            display: 'inline-flex',
                            p: 0.8,
                            borderRadius: '50%',
                            color: theme.palette.text.secondary,
                            bgcolor: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.3s ease',
                        }}
                    >
                        {Icons.default.ArrowOutward}
                    </Box>}
                </Box>
            </Box>
        </Link>
    )
}
const allMenu = [
    { id: 'menuitem-home', view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/home)\/?$/], permission: true, label: "Home", children: null, link: `/faculty/home`, icon: Icons.default.HomeIconOutlined, activeIcon: Icons.default.HomeIcon },
    { id: 'menuitem-practice-with-simba', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/practice-with-simba)\/?$/, /^(\/faculty\/practice-with-simba)\/\w+\/?$/], permission: "simba_ai", label: "Practice Sessions with Simba", children: null, link: `/faculty/practice-with-simba`, icon: Icons.default.SubjectsOutlined, activeIcon: Icons.default.Subjects },
    { id: 'menuitem-materials', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/material)\/?$/, /^(\/faculty\/material\/\d+)\/?$/, /^(\/faculty\/material\/add)\/?$/], permission: true, label: "Study Materials", children: null, link: `/faculty/material`, icon: Icons.default.DescriptionIconOutlined, activeIcon: Icons.default.DescriptionIcon },
    { id: 'menuitem-class-resources', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/class-sessions)\/?$/, /^(\/faculty\/class-sessions\/\d+)\/?$/], permission: true, label: "Beyond Class Resources", children: null, link: `/faculty/class-sessions`, icon: Icons.default.ClassOutlined, activeIcon: Icons.default.Class },
    { id: 'menuitem-assignment', view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/assignment)\/?$/, /^(\/faculty\/assignment)\/\d+\/?$/], permission: true, label: "Assignments", children: null, link: `/faculty/assignment`, icon: Icons.default.AssignmentIconOutlined, activeIcon: Icons.default.AssignmentIcon },
    { id: 'menuitem-exams', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/exams)\/?$/, /^(\/faculty\/addexam)\/?$/, /^(\/faculty\/exams\/\d+)\/?$/, /^(\/faculty\/exams\/\d+\/questions)\/?$/, /^(\/faculty\/exams\/\d+\/addquestions)\/?$/, /^(\/faculty\/participations)\/?$/, /^(\/faculty\/exams\/\d+\/participation)\/?$/, /^(\/faculty\/exams\/\d+\/evaluate\/\d+)\/?$/], permission: true, label: "Exams", link: "/faculty/exams", children: null, activeIcon: Icons.default.QuizIcon, icon: Icons.default.QuizIconOutlined },
    { id: 'menuitem-quizzes', view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/quizzes)\/?$/, /^(\/faculty\/quizzes)\/\d+\/?$/], permission: true, label: "Quizzes", children: null, link: `/faculty/quizzes`, icon: Icons.default.PsychologyAltOutlined, activeIcon: Icons.default.PsychologyAlt },
    { id: 'menuitem-questionbanks', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/questionbank)\/?$/, /^(\/faculty\/questionbank)\/\d+\/?$/], permission: true, label: "Question Banks", children: null, link: `/faculty/questionbank`, icon: Icons.default.QuestionMarkOutlined, activeIcon: Icons.default.QuestionMark },
    { id: 'menuitem-codelabs', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [], secondaryIcon: Icons.small.OpenInNewIcon, target: "_blank", label: "Coding labs", permission: true, children: null, link: getCodingLabsLink, activeIcon: Icons.default.CodeLab, icon: Icons.default.CodeLab },
    { id: 'menuitem-discussions', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/discussions)\/?$/, /^(\/faculty\/discussions\/\w+)\/?$/, /^(\/faculty\/discussion\/\w+)\/?$/, /^(\/faculty\/my-discussions)\/?$/, /^(\/faculty\/my-discussions\/\w+)\/?$/], permission: true, link: "/faculty/discussions", label: "Discussions", children: null, activeIcon: Icons.default.Discussions, icon: Icons.default.DiscussionsOutlined },
    { id: 'menuitem-online-classes', view: ["left-panel", "opened-bottom-bar"], headerText: "Online Classes", activeMatchRegexes: [/^(\/faculty\/online-classes)\/?$/, /^(\/faculty\/class\/[\w-]+)\/?$/], permission: true, label: "Online Classes", children: null, link: "/faculty/online-classes", activeIcon: Icons.default.OndemandVideoIconOutlined, icon: Icons.default.OndemandVideoIconOutlined },
    { id: 'menuitem-hybrid-classes', view: ["left-panel", "opened-bottom-bar"], headerText: "Hybrid Classes", activeMatchRegexes: [/^(\/faculty\/hybrid-classes)\/?$/, /^(\/faculty\/hybrid-class\/[\w-]+)\/?$/], permission: true, label: "Hybrid Classes", children: null, link: "/faculty/hybrid-classes", activeIcon: Icons.default.HybridClasses, icon: Icons.default.HybridClassesOutlined },
    { id: 'menuitem-meetings', view: ["left-panel", "opened-bottom-bar"], headerText: "Webinars and Meetings", activeMatchRegexes: [/^(\/faculty\/meetings)\/?$/, /^(\/faculty\/meeting\/[\w-]+)\/?$/, /^(\/faculty\/webinar\/[\w-]+)\/?$/], permission: true, label: "Webinars & Meetings", children: null, new: true, link: "/faculty/meetings", activeIcon: Icons.default.MeetingRooms, icon: Icons.default.MeetingRoomsOutlined },
    { id: 'menuitem-faq', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/faculty\/faq)\/?$/], permission: true, label: "FAQs", children: null, link: `/faculty/faq`, icon: Icons.default.LiveHelpIconOutlined, activeIcon: Icons.default.LiveHelpIcon },
    { id: 'menuitem-support', view: ["left-panel", "opened-bottom-bar"], secondaryIcon: Icons.small.OpenInNewIcon, activeMatchRegexes: [], target: "_blank", permission: true, label: "Support", children: null, link: ALIVE_SUPPORT_URL, icon: Icons.default.SupportAgentOutlined, activeIcon: Icons.default.SupportAgent },
    { id: 'menuitem-erp', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [], permission: true, label: "ERP", children: null, link: ERPFacultyDashboardPageURL, icon: Icons.default.Logout, activeIcon: Icons.default.Logout },
]

const SidedrawerMenuItem = ( { item, isActive, sidebarOpenState, closeOnMobileScreen, active } ) => {

    const { isSideDrawerCollapsed } = useLayoutContext()
    const [collapseState, setCollapseState] = useState( false )
    const { palette, layout } = useTheme()
    const { pathname, search } = useLocation()


    return (
        <Box
            sx={{
                borderRadius: "5px",
                bgcolor: collapseState && palette.nav.sidebarHover
            }}>
            <Tooltip placement='right' enterDelay={0} disableInteractive arrow title={isSideDrawerCollapsed ? item.label : ''}>
                <Link className='default-link' target={item.target} id={item.id} to={!item.children ? typeof item.link === 'string' ? item.link : item.link() : pathname + search}>
                    <Box
                        onClick={item.children ? () => setCollapseState( !collapseState ) : closeOnMobileScreen}
                        sx={{
                            color: isActive ? palette.nav.activeFont : palette.nav.font,
                            borderRadius: layout.borderRadius,
                            display: 'flex',
                            alignItems: 'center',
                            padding: 1,
                            paddingY: 0.5,
                            gap: '15px',
                            marginY: '2px',
                            minWidth: closedSidebarWidth - 20,
                            cursor: 'pointer',
                            position: 'relative',
                            background: isActive ? palette.nav.activeSidebarItem : 'none',
                            '&:hover': {
                                background: !isActive ? palette.nav.sidebarItemHoverBg : palette.nav.activeSidebarItem,
                            },
                        }}
                    >
                        <Typography sx={{ color: 'inherit', padding: '2px', position: 'relative', fontSize: '18px', display: 'flex', alignItems: 'center' }}>
                            {item.icon}
                        </Typography>
                        <Box sx={{ flexGrow: 1, gap: '5px', justifyContent: 'space-between', display: 'flex', alignItems: 'center', flexShrink: 0, color: 'inherit', fontWeight: isActive ? '500' : '300', fontSize: '14px', textAlign: 'center' }}>
                            <Typography noWrap sx={{ display: 'flex', gap: '5px', alignItems: 'center', fontWeight: isActive ? '500' : '400', opacity: !isSideDrawerCollapsed ? 1 : 0, fontSize: '14px', color: 'inherit' }}>
                                {item.label}
                            </Typography>
                            <Box component='span' sx={{ color: palette.text.secondary }}>
                                {item.children ? Icons.small.KeyboardArrowDown : item.secondaryIcon || ''}
                            </Box>
                        </Box>
                    </Box>
                </Link>
            </Tooltip>
            {item.children && <Collapse in={collapseState}>
                <Box
                    sx={{
                        flexDirection: "column",
                        paddingBottom: "10px",
                        display: "flex",
                        gap: "5px",
                        paddingRight: "20px",
                        paddingLeft: "30px",
                        position: "relative",

                        "&::before": {
                            display: "inline-block",
                            content: "''",
                            position: "absolute",
                            background: palette.nav.font + "88",
                            height: "calc(100% - 20px )",
                            borderRadius: "0 2px 2px 0",
                            left: "15px",
                            width: "1px",
                            zIndex: 324434,
                            top: "0",
                        }
                    }}>
                    {item.children.map( ( sublink, index ) => {
                        const activeChild = item.activeMatchRegexes[index].some( re => active.match( re ) )
                        return (
                            <Link className='default-link' key={sublink} to={item.link[index]}>
                                <Box
                                    onClick={closeOnMobileScreen}
                                    sx={{
                                        display: "flex",
                                        borderRadius: "5px",
                                        padding: "2px 5px",
                                        gap: "20px",
                                        alignItems: "center",
                                        bgcolor: activeChild ? palette.nav.activeSidebarItem : "none",
                                        color: activeChild ? palette.nav.activeFont : palette.nav.font,
                                        cursor: "pointer",
                                        position: "relative",

                                        // "&::before": {
                                        //     display: activeChild ? "inline-block" : "none",
                                        //     content: "''",
                                        //     position: "absolute",
                                        //     background: "#fff",
                                        //     height: "60%",
                                        //     borderRadius: "0 2px 2px 0",
                                        //     left: 0,
                                        //     width: "2px",
                                        //     zIndex: 324434,
                                        //     top: "50%",
                                        //     transform: "translate(0,-50%)"
                                        // },

                                        "&:hover": {
                                            background: !activeChild ? palette.nav.activeSidebarItem + "aa" : palette.nav.activeSidebarItem,
                                        }
                                    }}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            flexShrink: 0,
                                            color: "inherit",
                                            fontWeight: activeChild ? "500" : "400",
                                            fontSize: "14px",
                                            textAlign: "center"
                                        }}>{sublink}</Typography>
                                </Box>
                            </Link>
                        )
                    } )}
                </Box>
            </Collapse>}
        </Box>
    )
}

const SideDrawer = function ( { closeSideMenu } ) {
    const { sidebarOpenState, setNavHeadText, active, setMenuState, menuState, sidebarWidth, minSidebarCollapseWidth, setIsSideDrawerCollapsed, isSideDrawerCollapsed } = useLayoutContext()

    const [menu] = useState( allMenu )

    const { palette, shadows, border, layout, alpha } = useTheme()
    const navigate = useNavigate()

    const UserStore = useUserStore()

    const closeOnMobileScreen = () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            closeSideMenu()
    }
    const toggleAuditMode = () => {
        if ( active.includes( '/audit' ) ) {
            let redirect = localStorage.getItem( 'audit_redirect' )
            if ( !redirect )
                redirect = ["ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) ? `/admin/home` : `/faculty/home`
            navigate( redirect )
        } else {
            localStorage.setItem( 'audit_redirect', `${active}${window.location.search}` )
            navigate( '/audit/' )
        }
        setMenuState( false )
    }

    useEffect( () => {
        for ( let i = 0; i < menu.length; i++ ) {
            const item = menu[i]
            const isActive = item.activeMatchRegexes.flat().some( re => active.match( re ) )
            if ( isActive ) {
                setNavHeadText( item.headerText ?? item.label )
                break
            }
        }
    }, [menu, active, setNavHeadText] )

    const hasPlacementsTrainingCoordinatorAccess = !!UserStore.getUser?.features_permissions?.placement_training
    const hasPlacementsTrackerCoordinatorAccess = !!UserStore.getUser?.features_permissions?.placement_coordinator
    const hasPlacementsMonitoringAccess = !!UserStore.getUser?.features_permissions?.placement_monitoring


    return (
        <Box>
            <Box sx={{
                display: { sm: "block", xs: "none" }
            }}>
                <Drawer
                    variant='persistent'
                    anchor='left'
                    open={true}
                    className='no-scrollbar'
                    slotProps={{
                        paper: {
                            className: "no-scrollbar",
                            sx: {
                                width: !isSideDrawerCollapsed ? sidebarWidth : closedSidebarWidth,
                                borderRadius: "0",
                                background: palette.nav.sidebar,
                                borderRight: "none",
                                transition: "200ms",
                                overflowX: "hidden"
                            }
                        }
                    }}
                    sx={{
                        background: 'transparent',
                        position: 'initial',
                        overflow: 'hidden',
                        width: !isSideDrawerCollapsed ? sidebarWidth : closedSidebarWidth,
                        height: '100%',
                        flexSrink: 0,
                        display: { sm: 'flex', xs: 'none' },
                        flexDirection: 'column',
                    }}
                >
                    <Box sx={{ position: 'relative', flexGrow: 1, overflow: 'hidden', display: 'flex', }} >
                        <Box className='sidebar-scrollbar' sx={{ display: 'flex', flexDirection: 'column', width: '100%', overflowX: 'clip', overflowY: 'auto', color: 'GrayText', alignItems: 'stretch', }} >
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: "10px",
                                    padding: "20px 10px",
                                    alignItems: "center"
                                }}>
                                <Box sx={{ padding: 0.7, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px', bgcolor: 'white', aspectRatio: '1 / 1' }}>
                                    <Box component='img' src={aliveLogo} alt='Logo' sx={{ width: '20px' }} />
                                </Box>
                                <Box sx={{ opacity: !isSideDrawerCollapsed ? 1 : 0 }}>
                                    <Typography variant='h6' sx={{ color: palette.nav.font, fontSize: '14px' }}>Alive</Typography>
                                    <Typography variant='body2' noWrap sx={{ color: palette.nav.font, fontSize: '12px', fontWeight: '300' }}>Acharya LMS platform</Typography>
                                </Box>
                                <IconButton sx={{ color: palette.nav.font, display: { sm: "none", xs: "flex" } }} onClick={() => setMenuState( false )}>
                                    {Icons.default.CloseIcon}
                                </IconButton>
                            </Box>
                            <Box className='sidebar-scrollbar' sx={{ padding: '0 10px 0 10px', flexGrow: 1, display: 'flex', flexDirection: 'column', overflowY: 'hidden', overflowX: 'clip', "&:hover": { overflowY: "overlay" } }}>
                                {menu.map( item => {
                                    const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                    let permission = false
                                    if ( typeof item.permission === 'boolean' )
                                        permission = item.permission
                                    else if ( typeof item.permission === 'string' )
                                        permission = UserStore.getUser?.features_permissions?.[item.permission] ?? false

                                    if ( permission )
                                        return <SidedrawerMenuItem active={active} closeOnMobileScreen={closeOnMobileScreen} item={item} isActive={isActive} sidebarOpenState={sidebarOpenState} key={item.id} />
                                    return null
                                } )}
                                <Box sx={{ flexGrow: 1 }} />
                                <Box sx={{ minWidth: 0, pb: "20px", mt: 2, position: "sticky", bottom: 0, bgcolor: palette.nav.sidebar, overflow: "visible", "::before": { content: `''`, position: "absolute", bottom: "100%", height: "40px", width: "100%", pointerEvents: "none", background: `linear-gradient(to top, ${palette.nav.sidebar}, transparent)` } }}>
                                    {( hasPlacementsTrainingCoordinatorAccess || hasPlacementsTrackerCoordinatorAccess ) && <EcosystemPortalCard isSideDrawerCollapsed={isSideDrawerCollapsed} />}
                                    {hasPlacementsMonitoringAccess && !hasPlacementsTrainingCoordinatorAccess && <Box component={Link} to={`/placements-monitoring`} sx={{ color: palette.nav.font, borderRadius: layout.borderRadius, bgcolor: palette.nav.sidebar, display: 'flex', alignItems: 'center', padding: 1, gap: '15px', marginY: '2px', minWidth: closedSidebarWidth - 20, cursor: 'pointer', position: 'relative', background: palette.secondary.light + "44", '&:hover': { background: palette.secondary.light + "66" } }}>
                                        <Tooltip placement='right' enterDelay={0} disableInteractive arrow title={!isSideDrawerCollapsed ? '' : 'Placements Monitoring'}>
                                            <IconButton color='secondary' disableFocusRipple disableRipple disableTouchRipple sx={{ padding: '2px', borderRadius: '5px', transform: 'scale(0.9)', position: 'relative', fontSize: '18px' }}>
                                                {Icons.default.Work}
                                            </IconButton>
                                        </Tooltip>
                                        <Typography noWrap sx={{ color: "secondary.main", opacity: !isSideDrawerCollapsed ? 1 : 0, fontSize: '0.875rem' }}>Placements Monitoring</Typography>
                                    </Box>}
                                    <Box onClick={() => setIsSideDrawerCollapsed( prev => !prev )} sx={{ color: palette.nav.font, borderRadius: layout.borderRadius, bgcolor: palette.nav.sidebar, display: 'flex', alignItems: 'center', padding: 1, gap: '15px', marginY: '2px', minWidth: closedSidebarWidth - 20, cursor: 'pointer', position: 'relative', '&:hover': { background: palette.nav.sidebarItemHoverBg } }}>
                                        <Tooltip placement='right' enterDelay={0} disableInteractive arrow title={!isSideDrawerCollapsed ? '' : 'Expand Sidebar'}>
                                            <IconButton color='inherit' disableFocusRipple disableRipple disableTouchRipple sx={{ padding: '2px', borderRadius: '5px', transform: 'scale(0.9)', position: 'relative', fontSize: '18px' }}>
                                                {!isSideDrawerCollapsed ? Icons.default.MenuClose : Icons.default.Menu}
                                            </IconButton>
                                        </Tooltip>
                                        <Typography noWrap sx={{ opacity: !isSideDrawerCollapsed ? 1 : 0, fontSize: '0.875rem' }}>Collapse Sidebar</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box >
                </Drawer >
            </Box >

            {/* Bleeding Bottom Navigation Bar for devices with small screen */}
            < Box sx={{ display: { sm: 'none', xs: 'block' } }}>
                <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'space-evenly', padding: '10px 20px', background: palette.layoutBackground }}>
                    {menu.filter( item => item.view.includes( "bleeding-bottom-bar" ) ).map( item => {
                        const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                        return (
                            <Box key={item.id}>
                                <Link to={item.link} className='default-link' >
                                    <Box sx={{ py: 1, color: palette.nav.font, display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '5px' }}>
                                        <Box sx={{ background: isActive ? palette.nav.activeSidebarItem : 'none', fontSize: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 1, borderRadius: 10, color: isActive ? palette.nav.activeFont : palette.nav.font, '&:hover': { background: !isActive ? palette.nav.sidebarItemHoverBg : palette.nav.activeSidebarItem } }}>{item.icon}</Box>
                                        <Typography sx={{ color: 'inherit', fontSize: '12px', textAlign: 'center' }}>{item.label}</Typography>
                                    </Box>
                                </Link>
                            </Box>
                        )
                    } )}
                    <Box sx={{ color: palette.nav.font, display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '5px', cursor: 'pointer' }} onClick={() => setMenuState( true )}>
                        <Box sx={{ color: 'inherit', p: 1, fontSize: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{Icons.default.Menu}</Box>
                        <Typography sx={{ color: 'inherit', fontSize: '12px', textAlign: 'center' }}>More</Typography>
                    </Box>
                </Box>
                <SwipeableDrawer
                    sx={{ background: "transparent", zIndex: { sm: "initial", xs: "120000" }, overflow: "hidden", width: menuState ? sidebarWidth : 0, flexSrink: 0, display: { xs: "flex", sm: "none" }, flexDirection: "column" }}
                    anchor="bottom"
                    open={menuState}
                    className="no-scrollbar"
                    keepMounted={false}
                    swipeAreaWidth={0}
                    onClose={() => setMenuState( false )}
                    onOpen={() => setMenuState( true )}
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { borderRadius: `${layout.borderRadius * 4 + "px"} ${layout.borderRadius * 4 + "px"} 0 0`, background: palette.nav.sidebar, borderRight: "none", maxHeight: "80%" } }
                    }}
                >
                    <Box sx={{ position: "relative", width: "100%", my: 1 }}>
                        <Box sx={{ position: "absolute", left: "50%", transform: `translateX(-50%)`, height: 10, borderRadius: 5, width: 80, bgcolor: palette.action.selected }} />
                    </Box>
                    <Box
                        sx={{
                            position: "relative",
                            flexGrow: 1,
                            overflow: "auto"
                        }}>
                        {( ["PRINCIPAL", "HOD", "ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) || UserStore.getUser.user_auditor ) && <Box
                            onClick={toggleAuditMode}
                            sx={{
                                display: { xs: "flex", md: "none" },
                                gap: "10px",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "10px",
                                margin: "20px",
                                padding: "5px 10px",
                                boxShadow: shadows[1],
                                bgcolor: palette.contentBg,
                                border: border[1],
                                borderRadius: "10px",
                                cursor: "pointer"
                            }}>
                            <Typography color={palette.common.font} variant="subtitle2" sx={{
                                fontSize: "12px"
                            }}>Audit Mode</Typography>
                            <CustomSwitch size="small" checked={active.startsWith( '/audit' )} onChange={toggleAuditMode} />
                        </Box>}
                        <Box
                            className="sidebar-scrollbar"
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill,100px)",
                                padding: "40px 20px",
                                flexWrap: "wrap",
                                width: "100%",
                                gap: "30px",
                                justifyContent: "space-evenly",
                                overflow: "auto",
                                color: "GrayText",
                                alignItems: "stretch"
                            }}>
                            {menu.filter( item => item.view.includes( "opened-bottom-bar" ) ).map( item => {
                                const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                return (
                                    <Box key={item.id} onClick={() => setMenuState( false )}>
                                        <Link to={item.link} className='default-link' >
                                            <Box
                                                sx={{
                                                    color: palette.nav.font,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    gap: "5px"
                                                }}>
                                                <Box
                                                    sx={{
                                                        fontSize: "20px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>{item.icon}</Box>
                                                <Typography
                                                    sx={{
                                                        color: "inherit",
                                                        fontSize: "12px",
                                                        textAlign: "center"
                                                    }}>{item.label}</Typography>
                                            </Box>
                                        </Link>
                                    </Box>
                                )
                            } )}
                        </Box>
                    </Box >
                </SwipeableDrawer >
            </Box >
        </Box >
    )
}

export default SideDrawer


